<template>
	<div v-if="details" class="poDe">
		<div v-if="type!=2&&type!=3" class="top" :class="{types:type==1}" @click="companyDe()">
			<el-image :src="details.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
			<div class="right">
				<div class="name">
					{{details.simple_name}}
				</div>
				<div class="num">
					{{details.person_count||'未获取到公司规模'}}
				</div>
			</div>
		</div>
		<div v-if="type!=1" class="desc" :style="{'margin-right':type==3?'0':'32px'}">
			<div class="title">
				公司介绍
				<i v-if="type==3" class="el-icon-edit-outline" style="font-size: 24px;" @click="edit()"></i>
			</div>
			<div class="descCon">
				{{details.company_descrption}}
			</div>
		</div>

		<div class="address" v-if="type!=1&&type!=3">
			<div class="title">
				{{type==1?'上班地址':'公司地址'}}
			</div>
			<div>
				{{details.company_address}}{{details.addres_detatil}}
			</div>
			<div class="map"></div>
		</div>

		<div v-if="type!=1&&details.images" class="photoG">
			<div class="title">
				公司相册
			</div>
			<div class="medium">
				<el-carousel :autoplay="false" type="card" height="254px" indicator-position="none" arrow="always">
				    <el-carousel-item v-for="(item,index) of details.images.split(',')" :key="index" class="mediumLi">
					  <el-image :src="item" fit="cover" class="photo" :preview-src-list="details.images.split(',')"></el-image>
				    </el-carousel-item>
				</el-carousel>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'poDe',
		props:['type','details'],//type==2没有公司头像
		data() {
			return {

			}
		},
		created() {

		},
		methods: {
			companyDe(){
				this.$router.push({ name: 'companyDe',query: {id:this.details.id } });
			},
			edit(){
				this.$router.push({ name: 'setBusiness',query:{type:2,status:2}});
			}
		}
	}
</script>

<style lang="scss">
	.medium{
		.el-carousel__arrow{
			background: rgba(0,0,0, .8);
			&:hover{
				background: rgba(0,0,0, .8);
			}
		}
	}
	
</style>
<style lang="scss" scoped>
	.poDe {
		padding: 32px 32px 32px 32px;
		background-color: #fff;
		border-radius: 16px;
		box-sizing: border-box;
		width: 100%;
		.types{
			cursor: pointer;
		}
		.title {
			font-size: 22px;
			margin-bottom: 22px;
			font-weight: bold;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.el-icon-edit-outline{
				cursor: pointer;
			}
		}
		
		.el-icon-edit-outline{
			cursor: pointer;
			margin-left: 8px;
			&:hover {
				color: #51A190;
			}
		}

		.top {
			display: flex;
			align-items: center;
			margin-right: 32px;
			.logo {
				width: 64px;
				height: 64px;
				margin-right: 12px;
				border-radius: 8px;
			}

			.right {
				height: 64px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;

				.name {
					color: #151515;
					font-size: 18px;
					font-weight: bold;
				}

				.num {
					font-size: 14px;
					color: #5E5E5E;
				}
			}
		}

		.desc {
			margin: 32px 0;
			.descCon {
				font-size: 18px;
			}
		}

		.address {
			margin-right: 32px;
		}

		.photoG {
			margin: 32px 0;
			&:last-child{
				margin-bottom: 0;
			}

			::-webkit-scrollbar {
				width: 8px;
				/*  设置纵轴（y轴）轴滚动条 */
				height: 8px;
				/*  设置横轴（x轴）轴滚动条 */
			}

			/* 滚动条滑块（里面小方块） */
			::-webkit-scrollbar-thumb {
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.2);
			}

			/* 滚动条轨道 */
			::-webkit-scrollbar-track {
				
				background: rgba(0,0,0, 0.1);
				border-radius: 10px;
				margin-right: 32px;
			}

			.medium {
				white-space: nowrap;
				overflow-x: auto;
				// display: flex;
				width: 100%;
				.mediumLi {
					// width: 411px;
					height: 254px;
					border-radius: 8px;
					overflow: hidden;
					margin-right: 16px;
					display: inline-block;
					.photo {
						width: 100%;
						height: 100%;
					}
				}
			}
		}



	}
</style>